"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentAuditClaimedInfectiousDiseaseTestDtoCodeEnum = void 0;
exports.instanceOfDocumentAuditClaimedInfectiousDiseaseTestDto = instanceOfDocumentAuditClaimedInfectiousDiseaseTestDto;
exports.DocumentAuditClaimedInfectiousDiseaseTestDtoFromJSON = DocumentAuditClaimedInfectiousDiseaseTestDtoFromJSON;
exports.DocumentAuditClaimedInfectiousDiseaseTestDtoFromJSONTyped = DocumentAuditClaimedInfectiousDiseaseTestDtoFromJSONTyped;
exports.DocumentAuditClaimedInfectiousDiseaseTestDtoToJSON = DocumentAuditClaimedInfectiousDiseaseTestDtoToJSON;
exports.DocumentAuditClaimedInfectiousDiseaseTestDtoToJSONTyped = DocumentAuditClaimedInfectiousDiseaseTestDtoToJSONTyped;
/**
 * @export
 */
exports.DocumentAuditClaimedInfectiousDiseaseTestDtoCodeEnum = {
    Mantoux: 'MANTOUX'
};
/**
 * Check if a given object implements the DocumentAuditClaimedInfectiousDiseaseTestDto interface.
 */
function instanceOfDocumentAuditClaimedInfectiousDiseaseTestDto(value) {
    if (!('code' in value) || value['code'] === undefined)
        return false;
    if (!('testDate' in value) || value['testDate'] === undefined)
        return false;
    return true;
}
function DocumentAuditClaimedInfectiousDiseaseTestDtoFromJSON(json) {
    return DocumentAuditClaimedInfectiousDiseaseTestDtoFromJSONTyped(json, false);
}
function DocumentAuditClaimedInfectiousDiseaseTestDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'code': json['code'],
        'testDate': json['testDate'],
    };
}
function DocumentAuditClaimedInfectiousDiseaseTestDtoToJSON(json) {
    return DocumentAuditClaimedInfectiousDiseaseTestDtoToJSONTyped(json, false);
}
function DocumentAuditClaimedInfectiousDiseaseTestDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'code': value['code'],
        'testDate': value['testDate'],
    };
}
//# sourceMappingURL=DocumentAuditClaimedInfectiousDiseaseTestDto.js.map